module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot6-2560x1440.83ee1f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot6-2560x1440.jpg
// module id = 1075
// module chunks = 37